module.exports = __webpack_public_path__ + "img/img01.6dabf372.png";